import { AUTH_SUCCESS, FETCH_PAYMENT_METHODS_SUCCESS, SET_PARTNER } from "app/actionTypes";
import { FETCH_PARTNER_DATA_SUCCESS } from "app/reducers/partnerActionTypes";
import get from "lodash/get";
import isString from "lodash/isString";

const defaultState = {
	code: undefined,
	enablePromotionCode: false,
	enableSponsorship: false,
	strategy: "signupFirst",
	currencyCode: undefined,
	marketingBanners: [],
	marketing: {},
	fallbackSpecialOffer: {},
	availablePaymentMethods: [],
	avisVerifies: {},
	metaTags: [],
	theme: {},
	footer: {},
	useBrowserBackOnProductPage: false,
	showPfsMessage: false,
	showTransportOfferOnly: false,
};

const _partnerReducer = (partner, partners = []) => {
	const currentPartner = partners.find(p => p?.code === partner?.code);
	let strategy;
	if (partner?.strategy) {
		strategy = partner.strategy;
	} else if (partners?.length > 0 && currentPartner && currentPartner.strategy) {
		strategy = currentPartner.strategy;
	} else {
		strategy = "signupFirst";
	}
	return {
		...(isString(partner?.code) && { code: partner.code }),
		strategy,
	};
};

export default function partnerReducer(partnerState = defaultState, action) {
	switch (action.type) {
		case FETCH_PARTNER_DATA_SUCCESS: {
			const data = action?.res?.data;
			const footerData = data?.footer;
			return {
				...partnerState,
				partnerRedirectionLink: footerData?.partnerRedirectionLink,
				socialNetworks: footerData?.socialNetworks,
				marketingBanners: data?.marketingBanners || [],
				marketing: data?.marketing || {},
				fallbackSpecialOffer: data?.fallbackSpecialOffer || {},
				avisVerifies: data?.avisVerifies || {},
				home: data?.home || {},
				authLandingText: data?.authLandingText || {},
				bookingAuthLandingText: data?.bookingAuthLandingText || {},
			};
		}
		case AUTH_SUCCESS: {
			return { ...partnerState, ..._partnerReducer(action.partner, action.partners) };
		}
		case FETCH_PAYMENT_METHODS_SUCCESS: {
			const data = get(action, "res.data") || {};
			return { ...partnerState, availablePaymentMethods: data.methods };
		}
		case SET_PARTNER:
			return {
				...partnerState,
				..._partnerReducer(
					{ code: action.partner, strategy: action.strategy },
					action.partners
				),
			};
		case "SET_STRATEGY":
			return Object.assign({}, partnerState, { strategy: action.strategy });
		default:
			return partnerState;
	}
}
